const type = 'SET_TIMELINE_EVENTS_TO_PRE_PAID';

const setTimelineEventsToPrePaid = (data = {}) => ({
  data,
  type,
});

export { type };
export default setTimelineEventsToPrePaid;
